<template>
	<article class="duplicated-product">
		<ManagingSection class="search-by-enter__container">
			<ManagingBox title="제품명">
				<input
					class="search-by-enter__target"
					type="text"
					v-model="productTitle"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main blue" button="button" @click="searching">
				검색하기
			</button>
			<button class="btn-main" button="button" @click="rewrite">
				다시작성
			</button>
		</div>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<p class="section__info__left">등록 : {{ totalCount }}건</p>
			</template>
			<table class="table-main duplicated-product__table">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<template v-if="listLength">
					<tbody v-for="(list, idx) in tableData" :key="idx">
						<tr v-for="item in list" :key="item.idProduct">
							<td>{{ item.idProduct }}</td>
							<td>
								<router-link
									class="link"
									:to="`/product/product-inquiry/${item.idProduct}`"
									target="_blank"
									>{{ item.productTitle }}</router-link
								>
							</td>
							<td>{{ item.brandTitle }}</td>
							<td>{{ item.productImg ? 'Y' : 'N' }}</td>
							<td>{{ item.readCount }}</td>
							<td>{{ item.wishCount }}</td>
							<td>{{ item.pouchCount }}</td>
							<td>{{ item.commentCount }}</td>
							<td>{{ dateParse(item.create_date) }}</td>
							<td>{{ dateParse(item.modified_date) }}</td>
							<td>
								<b
									:class="[
										'duplicated-product__table__is-display',
										{ green: item.isDisplay },
									]"
									>{{ item.isDisplay ? 'Y' : 'N' }}</b
								>
							</td>
						</tr>
					</tbody>
				</template>
				<tbody v-else-if="typeof listLength === 'number'">
					<tr>
						<td :colspan="thList.length">
							{{ getTableMsg }}
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				@to="paging($event.offset)"
				:totalItem="totalItem"
				:offset="page"
				:limit="limit"
				:pageLengPerOne="10"
			/>
		</ManagingSection>
	</article>
</template>

<script>
	import moment from 'moment';
	import { isEmpty, isEqual } from 'lodash';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'DuplicatedProduct',
		components: { ManagingSection, ManagingBox, PaginationBox },
		extends: SearchByEnter,
		data() {
			return {
				thList: [
					'제품번호',
					'제품명',
					'브랜드명',
					'사진',
					'조회',
					'위시',
					'픽수',
					'덧글',
					'등록일',
					'수정일',
					'전시',
				],
				listLength: null,
				tableData: null,
				totalCount: 0,
				productTitle: '',
				isSearching: false,
				page: 0,
				limit: 10,
				totalItem: 0,
			};
		},
		computed: {
			getTableMsg() {
				return this.isSearching
					? '검색 중 입니다.'
					: '검색결과가 없습니다.';
			},
		},
		created() {
			this.setFilter();
			this.getList();
		},
		methods: {
			setFilter() {
				const query = this.$route.query;
				if (isEmpty(query)) return;
				let value;
				Object.keys(query).forEach(key => {
					if (this.hasOwnProperty(key)) {
						value = query[key];
						switch (key) {
							case 'limit':
								this[key] = Number(value);
								break;
							case 'page':
								this[key] = (Number(value) - 1) * this.limit;
								break;
							case 'productTitle':
								this[key] = value;
								break;
						}
					}
				});
			},
			replaceQuery(params) {
				const curQuery = this.$route.query;
				if (isEqual(curQuery, params)) return;
				this.$router.replace({ query: params });
			},
			async getList() {
				try {
					this.isSearching = true;
					const params = {
						page: String(this.page / this.limit + 1),
						limit: String(this.limit),
						productTitle: this.productTitle,
					};
					this.replaceQuery(params);
					const { data } = await this.$axiosAdmin2.get(
						`/api/products/duplicate/0`,
						{ params }
					);
					this.listLength = data.resultList.length;
					this.tableData = data.resultList.reduce((acc, cur) => {
						const accLength = acc.length - 1;
						const prevItem =
							accLength > -1 ? acc[accLength][0] : null;
						if (
							prevItem &&
							prevItem.productTitle.trim() ===
								cur.productTitle.trim() &&
							prevItem.idBrand === cur.idBrand
						) {
							acc[accLength].push(cur);
						} else {
							acc.push([cur]);
						}
						return acc;
					}, []);
					this.totalCount = data.totalCount;
					this.totalItem = data.totalPageCount * this.limit;
				} catch (err) {
					console.error(err);
					alert(
						'제품리스트를 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				} finally {
					this.isSearching = false;
				}
			},
			rewrite() {
				this.limit = 10;
				this.page = 0;
				this.productTitle = '';
				this.getList();
			},
			searching() {
				this.page = 0;
				this.getList();
			},
			paging(offset) {
				this.page = offset;
				this.getList();
			},
			dateParse(str) {
				return str
					? moment(str, 'YYYYMMDDHHmmss').format('YYYY-MM-DD')
					: '-';
			},
		},
	};
</script>

<style lang="scss">
	.duplicated-product {
		.duplicated-product__table {
			tbody:nth-child(odd) {
				background-color: rgba(darkseagreen, 0.4);
			}
		}

		.duplicated-product__table__is-display {
			color: $red;

			&.green {
				color: $green;
			}
		}
	}
</style>
